import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useUserContext } from 'src/context/UserProvider';
import { sendTrackingEvent } from 'src/utils/gtm';
import { ProfilePageTabs, UIUser } from 'types';
import ProfileActions from './ProfileActions';

interface Props {
	activeTab: ProfilePageTabs;
	setActiveTab: (value: ProfilePageTabs) => void;
	forceMobileView?: boolean;
	isSelf: boolean;
	userProfileInfo: UIUser;
	showBannerBg: boolean;
}

const ProfileTabs = ({
	activeTab,
	setActiveTab,
	forceMobileView = false,
	isSelf,
	userProfileInfo,
	showBannerBg,
}: Props) => {
	const location = useLocation();
	const { isRecruiterLoggedIn } = useUserContext();
	return (
		/* Profile Page Tabs */
		<div
			className={classNames(
				'flex h-[48px] lg:h-[52px] justify-stretch w-full bg-[#FAFAFA] dark:bg-[#1F2A37] rounded-t-[8px] text-base md:text-xl font-[500] font-inter',
				forceMobileView ? 'rounded-t-[8px]' : 'rounded-[8px]',
			)}
		>
			<div className="flex w-full md:max-w-[300px] flex-1">
				<button
					className={classNames(
						'flex w-full md:max-w-[164px] cursor-pointer items-center justify-center py-[6px] rounded-[6px] relative',
						activeTab === ProfilePageTabs.Stats
							? 'bg-white dark:bg-[#18222D] text-[#7777E7]'
							: ' text-[#555770] dark:text-white ',
					)}
					onClick={() => {
						if (isRecruiterLoggedIn) {
							sendTrackingEvent({
								event: 'recr_profile_tab_stats',
								eventLabel: location.pathname,
							});
						} else {
							sendTrackingEvent({
								event: 'profile_tab_stats',
								eventLabel: location.pathname,
							});
						}

						setActiveTab(ProfilePageTabs.Stats);
					}}
				>
					Stats
					{activeTab === ProfilePageTabs.Stats ? (
						<div className="w-[90%] h-[2px] bg-[#7777E7] rounded-t[3px] absolute bottom-0"></div>
					) : null}
				</button>

				<button
					className={classNames(
						'flex w-full md:max-w-[164px] cursor-pointer items-center justify-center py-[6px] rounded-[6px] relative',
						activeTab === ProfilePageTabs.Profile
							? 'bg-white dark:bg-[#18222D] text-[#7777E7]'
							: ' text-[#555770] dark:text-white ',
					)}
					onClick={() => {
						if (isRecruiterLoggedIn) {
							sendTrackingEvent({
								event: 'recr_profile_tab_profile',
								eventLabel: location.pathname,
							});
						} else {
							sendTrackingEvent({
								event: 'profile_tab_profile',
								eventLabel: location.pathname,
							});
						}
						setActiveTab(ProfilePageTabs.Profile);
					}}
				>
					Profile
					{activeTab === ProfilePageTabs.Profile ? (
						<div className="w-[90%] h-[2px] bg-[#7777E7] rounded-t[3px] absolute bottom-0"></div>
					) : null}
				</button>
			</div>

			<div className="hidden md:flex w-full items-center justify-end pr-4 flex-1">
				<ProfileActions isSelf={isSelf} userProfileInfo={userProfileInfo} showBannerBg={showBannerBg} />
			</div>
		</div>
	);
};

export default ProfileTabs;
